<template>
  <div class="notifications-list">
    <p v-if="notificaciones.length === 0" class="notifications-list__empty">
      {{ leida ? $t("notificaciones.vacio_leidas") : $t("notificaciones.vacio_sin_leer") }}
    </p>
    <NotificacionCard
      v-for="notification in notificaciones"
      :key="notification.Id"
      :notificacion="notification"
      :leida="leida"
      @notificacion-leida="emit('refrescar-notificaciones')"
    />
  </div>
</template>

<script setup lang="ts">
import type { PropType } from "vue";
import NotificacionCard from "./NotificacionCard.vue";
import type { NotificacionModel } from "@api/api";

defineProps({
  notificaciones: {
    type: Array as PropType<NotificacionModel[]>,
    required: true,
  },
  leida: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits<{
  "refrescar-notificaciones": [];
}>();
</script>

<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/_themevars.scss";
@import "@/styles/figma.scss";

.notifications-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
  padding: var(--spacing-xs) 0 0;
}

.notifications-list__empty {
  margin: var(--spacing-md, 16px) 0;
  text-align: center;
  font-size: var(--font-size-body-md, 14px);
  color: var(--text-default-caption, #6b7280);
}
</style>
